
// 获取其他品牌在tab的顺序
export function getCurTab(brandId: number, brandList: any) {
  let index: any = -1
  brandList.forEach((brand: any, idx: number) => {
    if (Number(brand.brandId) === Number(brandId)) {
      index = idx
    }
  });
  return index
} 